const BASE = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

function getToken() {
  return localStorage.getItem("luxolor_token");
}

async function req(method, path, body) {
  const token = getToken();
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  
  const opts = { method, headers };
  if (body) opts.body = JSON.stringify(body);
  
  const res = await fetch(BASE + path, opts);
  
  if (res.status === 401) {
    localStorage.removeItem("luxolor_token");
    localStorage.removeItem("luxolor_user");
    window.location.href = "/login";
    throw new Error("Session expiree");
  }
  
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Erreur serveur");
  }
  return res.json();
}

async function login(username, password) {
  const formData = new URLSearchParams();
  formData.append("username", username);
  formData.append("password", password);
  
  const res = await fetch(`${BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: formData,
  });
  
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Identifiant ou mot de passe incorrect");
  }
  
  const data = await res.json();
  localStorage.setItem("luxolor_token", data.access_token);
  localStorage.setItem("luxolor_user", JSON.stringify(data.user));
  return data;
}

function logout() {
  localStorage.removeItem("luxolor_token");
  localStorage.removeItem("luxolor_user");
  window.location.href = "/login";
}

async function refreshUser() {
  try {
    const data = await req("GET", "/auth/me");
    localStorage.setItem("luxolor_user", JSON.stringify(data));
    return data;
  } catch(e) { return null; }
}

function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem("luxolor_user"));
  } catch {
    return null;
  }
}

export const api = {
  login,
  logout,
  getCurrentUser,
  refreshUser,
  getToken,

  // Visits
  getVisits: () => req("GET", "/visits/"),
  getCommercialDashboard: () => req("GET", "/commercial/dashboard"),
  getCommercialDashboardByDates: (dates) => req("GET", `/commercial/dashboard?dates=${dates.join(",")}`),
  getCommercialSnapshots: () => req("GET", "/commercial/snapshots"),
  getVisit: (id) => req("GET", `/visits/${id}`),
  getVisitDetail: (id) => req("GET", `/visits/${id}/detail`),
  createVisit: (data) => req("POST", "/visits/", data),
  updateVisit: (id, data) => req("PUT", `/visits/${id}`, data),
  deleteVisit: (id) => req("DELETE", `/visits/${id}`),
  upsertScores: (id, scores) => req("POST", `/visits/${id}/scores`, scores),
  exportJSON: (id) => req("GET", `/visits/${id}/export-json`),

  // Sections
  getSections: () => req("GET", "/sections/"),
  getAllSections: () => req("GET", "/sections/all"),
  createSection: (data) => req("POST", "/sections/", data),
  updateSection: (id, data) => req("PUT", `/sections/${id}`, data),
  toggleSection: (id) => req("PATCH", `/sections/${id}/toggle`),
  deleteSection: (id) => req("DELETE", `/sections/${id}`),

  // Checkpoints
  createCheckpoint: (data) => req("POST", "/sections/checkpoints/", data),
  updateCheckpoint: (id, data) => req("PUT", `/sections/checkpoints/${id}`, data),
  toggleCheckpoint: (id) => req("PATCH", `/sections/checkpoints/${id}/toggle`),
  deleteCheckpoint: (id) => req("DELETE", `/sections/checkpoints/${id}`),

  // Actions
  getActions: (visitId) => req("GET", `/actions/visit/${visitId}`),
  createAction: (visitId, data) => req("POST", `/actions/visit/${visitId}`, data),
  updateAction: (id, data) => req("PUT", `/actions/${id}`, data),
  deleteAction: (id) => req("DELETE", `/actions/${id}`),

  // Dashboard
  getStats: () => req("GET", "/dashboard/stats"),

  // Users
  getUsers: () => req("GET", "/auth/users"),
  createUser: (data) => req("POST", "/auth/users", data),
  deleteUser: (id) => req("DELETE", `/auth/users/${id}`),
  changePassword: (id, password) => req("PUT", `/auth/users/${id}/password`, { password }),

  validateVisit: (id) => req("PATCH", `/visits/${id}/validate`),
  unvalidateVisit: (id) => req("PATCH", `/visits/${id}/unvalidate`),

  // Stores
  getStores: () => req("GET", "/stores/"),
  getAllStores: () => req("GET", "/stores/all"),
  createStore: (data) => req("POST", "/stores/", data),
  updateStore: (id, data) => req("PUT", `/stores/${id}`, data),
  deleteStore: (id) => req("DELETE", `/stores/${id}`),
  getZones: () => req("GET", "/stores/zones"),

  // Auth extras
  register: (data) => req("POST", "/auth/register", data),
  getPendingUsers: () => req("GET", "/auth/pending"),
  getPendingCount: () => req("GET", "/auth/pending/count"),
  changeUserRole: (id, role) => req("PATCH", `/auth/users/${id}/role`, { role }),
  approveUser: (id) => req("PATCH", `/auth/users/${id}/approve`),
  toggleDashboardAccess: (id) => req("PATCH", `/auth/users/${id}/dashboard-access`),
  toggleSuperAdmin: (id) => req("PATCH", `/auth/users/${id}/super-admin`),

  // PDF
  getPdfUrl: (id) => `${BASE}/reports/${id}/pdf?token=${getToken()}`,
};
